export default function Impressum() {
  return (
    <div data-testid="page-impressum">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Rechtliches</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter mt-6">Impressum</h1>
        </div>
      </section>

      <section>
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-12 text-[#2C2A26]">
          <div>
            <h2 className="font-serif text-2xl font-medium">Angaben gemäß § 5 DDG</h2>
            <div className="mt-4 text-[#757067] font-light leading-relaxed space-y-1">
              <p>Lukas Stutz</p>
              <p>Mietkoch für Gastronomie & Events</p>
              <p>Schloßstraße 32</p>
              <p>64720 Michelstadt</p>
              <p>Deutschland</p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Kontakt</h2>
            <div className="mt-4 text-[#757067] font-light leading-relaxed space-y-1">
              <p>Telefon: +49 151 27282560</p>
              <p>E-Mail: mietkoch@stutz-cuisine.com</p>
              <p>Web: stutz-cuisine.com</p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Berufsbezeichnung & Gewerbe</h2>
            <div className="mt-4 text-[#757067] font-light leading-relaxed space-y-1">
              <p>Berufsbezeichnung: Koch (verliehen in Deutschland)</p>
              <p>Gewerbe angemeldet bei: Stadt Michelstadt</p>
              <p>
                Angemeldete Tätigkeiten: Küchendienstleistung für gewerbliche Auftraggeber
                (Mietkoch), Privatkoch-Dienstleistungen für Privatpersonen sowie die Vermittlung
                selbstständiger Küchendienstleister an Gastronomiebetriebe.
              </p>
              <p>
                Bei der Vermittlung werde ich ausschließlich als Vermittler tätig. Der Vertrag über
                den jeweiligen Einsatz kommt unmittelbar zwischen dem Auftraggeber und dem
                vermittelten Koch zustande. Eine Arbeitnehmerüberlassung nach dem AÜG findet nicht
                statt; eine Erlaubnis hierfür besteht nicht und ist nicht erforderlich.
              </p>
              <p>Zuständige Aufsichtsbehörde: Stadt Michelstadt, Gewerbeamt</p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Steuer</h2>
            <div className="mt-4 text-[#757067] font-light leading-relaxed space-y-1">
              <p>Steuernummer: 033/887/29523</p>
              <p>
                Eine Umsatzsteuer-Identifikationsnummer wird für die Abrechnung
                innergemeinschaftlicher Leistungen verwendet und auf entsprechenden Rechnungen
                ausgewiesen.
              </p>
              <p>
                Umsatzsteuerlich Regelbesteuerung — die Kleinunternehmerregelung nach
                §&nbsp;19&nbsp;UStG wird nicht angewendet.
              </p>
              <p>
                Bei Leistungen an Unternehmer mit Sitz in Österreich erfolgt die Abrechnung als
                innergemeinschaftliche Dienstleistung ohne deutsche Umsatzsteuer; die Steuerschuld
                geht auf den Leistungsempfänger über (Reverse Charge, Art.&nbsp;196 MwStSystRL).
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Hinweis für Nutzer in Österreich</h2>
            <div className="mt-4 text-[#757067] font-light leading-relaxed space-y-2">
              <p>
                Die vorstehenden Angaben gelten zugleich als Informationen nach
                §§&nbsp;5&nbsp;E-Commerce-Gesetz (ECG) und §&nbsp;25 Mediengesetz (Österreich).
              </p>
              <p>
                Unternehmensgegenstand: Küchendienstleistung (Mietkoch), Privatkoch-Dienstleistungen
                sowie die Vermittlung selbstständiger Küchendienstleister. Niederlassung und
                Gewerbestandort befinden sich ausschließlich in Deutschland; Einsätze und
                Vermittlungen erfolgen in Deutschland und Österreich.
              </p>
              <p>
                Bei grenzüberschreitenden Einsätzen sind die österreichischen bzw. deutschen
                Vorschriften zur Entsendung und Sozialversicherung (A1-Bescheinigung) sowie die
                jeweiligen Hygienevorschriften — in Deutschland §&nbsp;43&nbsp;IfSG, in Österreich
                die Lebensmittelhygiene-Schulung nach LMSVG — zu beachten.
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Lukas Stutz, Anschrift wie oben.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Haftungsausschluss</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt.
              Der Anbieter übernimmt jedoch keine Gewähr für die Richtigkeit,
              Vollständigkeit und Aktualität der bereitgestellten Inhalte. Externe
              Links wurden zum Zeitpunkt der Verlinkung sorgfältig geprüft; auf deren
              Inhalt hat der Anbieter keinen Einfluss.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Verbraucherstreitbeilegung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Europäische Plattform zur Online-Streitbeilegung (OS-Plattform) wurde von der
              Europäischen Kommission zum 20.&nbsp;Juli&nbsp;2025 eingestellt und steht nicht mehr
              zur Verfügung. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle bin ich nicht verpflichtet und nicht bereit. Ich bin
              jedoch stets bemüht, Meinungsverschiedenheiten im direkten Gespräch zu klären —
              melden Sie sich einfach bei mir.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">Urheberrecht</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Sämtliche Inhalte dieser Website (Texte, Bilder, Grafiken) unterliegen
              dem Urheberrecht. Eine Vervielfältigung, Bearbeitung oder Verwendung
              außerhalb der gesetzlich zulässigen Grenzen bedarf der schriftlichen
              Zustimmung des Anbieters.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
